export const APP_NAME = "Nimbus-AI-Admin";
export const APP_BASE_URL = import.meta.env.VITE_API_URL;

export const APP_VERSION = "1.0.0";
export const APP_KEY = APP_NAME + "V" + APP_VERSION;
